const DEFAULT_APP_URL = "http://localhost:5173/app";

export const APP_URL = import.meta.env.VITE_APP_URL ?? DEFAULT_APP_URL;

function appSignupUrl(extra: Record<string, string> = {}): string {
  const url = new URL(APP_URL, "https://loop.invalid");
  url.searchParams.set("signup", "1");
  for (const [key, value] of Object.entries(extra)) {
    url.searchParams.set(key, value);
  }
  if (APP_URL.startsWith("http://") || APP_URL.startsWith("https://")) {
    return url.toString();
  }
  return `${url.pathname}${url.search}${url.hash}`;
}

export const SIGNUP_URL = appSignupUrl({ plan: "free" });

export const STUDIO_SIGNUP_URL = appSignupUrl({ plan: "studio" });
